import { Button } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import logo from "../../assets/Support.svg"
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import ResNavBar from "../../components/ResNavBar/ResNavBar";
import localization from '../../Localization/Localization.json'
import AddTicket from "./AddTicket";
import "./Support.scss"
import TicketDone from "./TicketDone";
import TicketList from "./TicketList";
class Support extends Component {
  state = {
    supportCase: "list",
  };

  componentDidMount() {}

  showTicketsDone = () => {
    this.setState({supportCase : "done"})
  }
  showTicketsList = () => {
    this.setState({supportCase : "list"})
  }
  showNewIssue = () => {
    this.setState({supportCase : "add"})  
  }
  showEmptyIssue = () => {
    this.setState({supportCase : "empty"})   
  }

  handelEmptyAndList = () => {

  }


  renderSwitch = (param) => {
    switch (param) {
      case "empty":
        return <div className="support-empty">
                    <img src={logo} alt="logo" />
                    <p>{localization.noanyissue[this.props.currentLang]}</p> 
                    <Button className="primary-light" size="large" type="primary" onClick={() => this.setState({supportCase : "add"})}>New Issue</Button>
                </div>;
      case "list":
        return  <TicketList currentLang={this.props.currentLang} showNewIssue={this.showNewIssue} />; 
      case "done":
        return <TicketDone localization={localization} currentLang={this.props.currentLang}/>; 
      case "add":
        return <AddTicket showTicketsList={this.showTicketsList} showTicketsDone={this.showTicketsDone} />;
      default:
        return "empty";
    }
  };

  render() {
    return (
      <div className="support-page-wrapper">
          <Header />
        <div className="container">
          <div className="support-content-wrapper">
            {this.renderSwitch(this.state.supportCase)}
          </div>
        </div>
        {/* <Footer /> */}
        <ResNavBar /> 
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    currentUser : state.user.currentUser,
    currentLang : state.user.currentLang,
}) 
  
export default connect(mapStateToProps)(Support);